export default class WorkOrderFilters {
  public showNotAvailableAnymore: boolean = false;
}
